export default function (keys, prefix) {
    return keys.reduce((accumulator, current) => {
        return { ...accumulator, [current]: `${prefix}/${current}` }
    }, {})
}
